import 'core-js/es6/reflect';
import 'core-js/fn/object/assign';

import 'picturefill';
import 'clip-path';